module.exports = __webpack_public_path__ + "img/cert_02.74a5af8d.jpg";